import { Box, Link } from '@terminal/design-system';
import ImageShimmer from '../ImageShimmer/ImageShimmer';

export default function PressCard({ card }) {
  let href = '';
  if (card.newsGroup) {
    href = card.newsGroup.news.url;
  } else if (card.slug) {
    href = card.slug;
  } else {
    href = card.pressGroup.pressRelease.url;
  }

  let image: { sourceUrl: string; altText: string } = {
    sourceUrl: '',
    altText: '',
  };
  if (card.newsGroup) {
    image = {
      sourceUrl: card.newsGroup.news.logo.sourceUrl,
      altText: card.newsGroup.news.publication,
    };
  }

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-ca', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <Link
      href={card.slug ? `/press/${href}` : href}
      target={card.slug ? '_self' : '_blank'}
      rel={card.slug ? '' : 'noreferrer noopener'}
      display="block"
      p="8"
      minH="100%"
      bgColor="white"
      boxShadow="0 0.125rem 0.5rem rgba(28, 40, 45, 0.2)"
      transition="box-shadow 0.2s ease-in-out"
      _hover={{
        boxShadow: '0 0.5rem 0.8rem rgba(28, 40, 45, 0.2)',
      }}
    >
      {image.sourceUrl && (
        <ImageShimmer
          src={image.sourceUrl}
          alt={image.altText}
          width="140"
          height="40"
          style={{ objectFit: 'contain' }}
          layout="intrinsic"
        />
      )}
      <Box mt="2" fontSize="2xl" lineHeight="7" fontWeight="semibold" color="grey.900">
        {card.title}
      </Box>
      <Box mt="4">{formatDate(card.date)}</Box>
    </Link>
  );
}
